import Cookies from "universal-cookie";


const cookies = new Cookies();
const BASE = process.env.SERVER_URL || "";
const enc = encodeURIComponent;

const authorization = () => {
  const { token } = cookies.get("userId") || {};
  return { Authorization: `Bearer ${token}` };
};

const paramsFor = ({
  cause,
  status,
  search,
  page,
  pageSize,
  format,
} = {}) => {
  const params = new URLSearchParams();
  if (cause && cause !== "all") params.set("cause", cause);
  if (status && status !== "all") params.set("status", status);
  if (search) params.set("search", search);
  if (page !== undefined) params.set("page", String(page));
  if (pageSize !== undefined) params.set("pageSize", String(pageSize));
  if (format) params.set("format", format);
  return params;
};

const urlFor = (projectId, params) => (
  `${BASE}/project/${enc(projectId)}/disbursementCoverage?${params.toString()}`
);

export const fetchDisbursementCoverage = async (
  projectId,
  { cause, status, search, page = 0, pageSize = 50 } = {},
) => {
  if (!projectId) return null;
  try {
    const response = await fetch(
      urlFor(projectId, paramsFor({ cause, status, search, page, pageSize })),
      { headers: authorization() },
    );
    if (!response.ok) return null;
    return await response.json();
  } catch {
    return null;
  }
};

export const downloadDisbursementCoverage = async (
  projectId,
  { cause, status, search } = {},
) => {
  if (!projectId) return null;
  try {
    const response = await fetch(
      urlFor(projectId, paramsFor({ cause, status, search, format: "csv" })),
      { headers: authorization() },
    );
    if (!response.ok) return null;
    return await response.blob();
  } catch {
    return null;
  }
};
